import * as React from "react"
import Loader from "../ui/Loader";
import {useAppSelector} from "../../redux/storeHooks";

const AppLoader = () => {

  const loaderVisible:boolean = useAppSelector((store) => store.globalState.loaderVisible);

  if (!loaderVisible) {
    return null
  }

  return (
    <div className="overlay overlay--visible">
      <Loader className={"member-loader--white"}/>
    </div>
  )
}

export default AppLoader